import { ProcessStep } from "../types";

export const sumMachineTimes = ({
  lines,
  industrialProcess,
  companyMachineId,
}: {
  lines: { processSteps: ProcessStep[] }[];
  industrialProcess: string;
  companyMachineId: string;
}) => {
  let machinePreparationTime = 0;
  let otherMachineTime = 0;

  for (const line of lines) {
    for (const step of line.processSteps) {
      if (
        step.industrialProcess !== industrialProcess ||
        step.companyMachineId !== companyMachineId
      ) {
        continue;
      }
      machinePreparationTime += step.machinePreparationTime ?? 0;
      otherMachineTime += step.otherMachineTime ?? 0;
    }
  }

  return { machinePreparationTime, otherMachineTime };
};
